// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import color from 'michelangelo/dist/Components/styles/color'

const Page: ReactComponentStyled<{}> = styled.div`
  position: relative;
  height: 100vh;
  background-image: ${color.greyBlueGradient};
`
Page.displayName = 'Page'

const NotFoundContainer: ReactComponentStyled<{}> = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-width: 770px;
  width: 100%;
  line-height: 1.4;
  padding: 110px 40px;
  text-align: center;
  background: ${color.white};
  -webkit-box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.1);
  box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.1);

  @media only screen and (max-width: 770px) {
    padding: 50px 10px;
    width: 90%;
  }
  @media only screen and (orientation: landscape) and (max-height: 425px) {
    padding: 50px 10px;
    width: 90%;
  }
  @media only screen and (max-height: 329px) {
    padding: 30px 10px;
  }
`
NotFoundContainer.displayName = 'NotFoundContainer'

const FourOhFour: ReactComponentStyled<{}> = styled.div`
  font-family: Raleway;
  position: relative;
  height: 180px;
`
FourOhFour.displayName = 'FourOhFour'

const H1: ReactComponentStyled<{}> = styled.h1`
  font-family: Raleway;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 165px;
  font-weight: 700;
  margin: 0px;
  color: ${color.lightDefault};
  text-transform: uppercase;
  @media only screen and (max-width: 480px) {
    font-size: 141px;
  }
`
H1.displayName = 'H1'

const Zero: ReactComponentStyled<{}> = styled.span`
  color: ${color.info};
`
Zero.displayName = 'Zero'

const H2: ReactComponentStyled<{}> = styled.h2`
  font-family: Raleway;
  font-size: 22px;
  font-weight: 400;
  text-transform: uppercase;
  color: ${color.lightDefault};
  margin-top: 0px;
  margin-bottom: 25px;
  @media only screen and (max-width: 767px) {
    font-size: 18px;
  }
`
H2.displayName = 'H2'

type NotFoundState = {
  loaded: boolean
}
class NotFound extends Component<{}, NotFoundState> {
  constructor (props: any) {
    super(props)
    this.state = { loaded: false }
  }

  componentDidMount () {
    this.setState({ loaded: true })
  }

  render () {
    if (!this.state.loaded) {
      return null
    }
    return (
      <Page>
        <NotFoundContainer>
          <FourOhFour>
            <H1>4<Zero>0</Zero>4</H1>
          </FourOhFour>
          <H2>the page you requested could not be found</H2>
        </NotFoundContainer>
      </Page>
    )
  }
}

export default NotFound
